import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { MembershipGroupCardTag } from 'src/features/memberships/types';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/tags/';

interface DTO extends ListDTO {
    parkingId: string;
    membershipGroupId: number;
}

type QueryFnType = typeof queryFn;
const queryFn = ({
    parkingId,
    membershipGroupId,
    ...params
}: DTO): Promise<ListResponseSmartParkAPI<MembershipGroupCardTag>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, membershipGroupId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export {
    RESOURCE as LIST_MEMBERSHIP_GROUP_CARD_TAGS_RESOURCE,
    queryFn as listMembershipGroupCardTags,
    useQueryHook as useListMembershipGroupCardTags,
};
export type { DTO as ListMembershipGroupCardTagsDTO };
